export const KIOSK_COMPONENTS_DEFAULT_THEME_OVERRIDES = {
  '--body-background-color': '#EEEEEE',
};
